// extracted by mini-css-extract-plugin
export default {"warp":"preset_apps_warp__g9Ksw","home_title":"preset_apps_home_title__Q-2UH","foot":"preset_apps_foot__8YLQY"};